export function generateTextColor() {
  let color = '#';
  for (let i = 0; i < 3; i++) color += `0${Math.floor((1 + Math.random()) * Math.pow(16, 2) / 2).toString(16)}`.slice(-2);
  return color;
}
export class Debugger {
  constructor(prefix) {
    this._color = generateTextColor();
    this.connectionType = '';
    this.log = (...args) => {
      /* eslint-disable no-console */
      let firstLine = `%c[${this.connectionType ? `${this.connectionType.toLowerCase()}-` : ''}${this._prefix}]: `;
      if (console.groupCollapsed && args.length > 1) {
        const [first, ...rest] = args;
        if (Array.isArray(first)) {
          const [message, color2] = first;
          firstLine += message;
          console.groupCollapsed(firstLine, `color:${this._color};`, color2);
        } else {
          firstLine += first;
          console.groupCollapsed(firstLine, `color:${this._color};`);
        }
        console.log(...rest);
        console.groupEnd();
        return;
      }
      const [first, ...rest] = args;
      firstLine += first;
      console.log(firstLine, `color:${this._color};`, ...rest);
      /* eslint-enable no-console */
    };
    this._prefix = prefix;
  }
}